import { createValidation } from '_metronic/helpers'
import { TFunction } from '_metronic/i18n/Metronici18n'
import * as Yup from 'yup'

export const faturaSchema = (t: TFunction) => {
  const v = createValidation(t)
  return Yup.object().shape({
    observacao: Yup.string().trim().max(512, v.maxField(512)).nullable().notRequired(),
    valor: Yup.number()
      .nullable()
      .when('action', {
        is: 'adicional',
        then: (schema) =>
          schema.min(0.1, v.minField(0.1)).required(v.requiredField('valor_adicional')),
        otherwise: (schema) => schema.notRequired(),
      }),
  })
}
